import ExternalLink from '@/ev/ExternalLink';
import { Content, EvGuideSection, Title } from '@/ev/styles';
import TrackWrapper from '~/components/common/TrackWrapper';
import LevelGuide from './LevelGuide';

export default function EvCharging() {
  return (
    <TrackWrapper event={{ eventName: 'Viewed - Charging an Ev' }}>
      <EvGuideSection className="grid gap-3xl bg-white sm:gap-4xl md:gap-0">
        <div className="grid gap-xl sm:gap-2xl">
          <Title>Charging an EV</Title>
          <Content className="max-w-[1056px]">
            Many EV owners will want to install an EV charger at home for easy
            access to charging. If you’re one of them, you should know that EV
            charging at home is typically split out into levels: Level 1 and
            Level 2. Level 3 charging (typically split into DC Fast Charging and
            Supercharging) is only available at public charging stations.
          </Content>
        </div>
        <div className="grid grid-cols-1 gap-4xl divide-y divide-border-weak sm:gap-5xl md:grid-cols-3 md:gap-2xl md:divide-y-0 md:pt-2xl">
          <LevelGuide level="1" />
          <LevelGuide level="2" />
          <LevelGuide level="3" />
        </div>
        <Content className="max-w-[1056px] md:pt-5xl">
          For most people, a Level 2 charger works perfectly well. If you can
          plan out charging ahead of time, even a Level 1 charger can work. If
          you do decide to spring for a Level 3 charger, keep in mind that
          you’ll still want to use Level 1 and Level 2 chargers from time to
          time — using only Level 3 charging{' '}
          <ExternalLink
            section="Charging an EV"
            url="https://www.myev.com/research/interesting-finds/is-dc-fast-charging-bad-for-your-electric-car#:~:text=However%2C%20a%20study%20conducted%20by,difference%20isn%27t%20particularly%20pronounced."
            data-testid="Fast Charging Link"
          >
            can expedite EV battery degradation
          </ExternalLink>
          . Speaking of battery degradation, we recommend consistently charging
          your battery up to 80% to maintain its health.
        </Content>
      </EvGuideSection>
    </TrackWrapper>
  );
}
